import { coreText } from '../tokens';
export function getDesignTypography() {
    return {
        fontFamily: [
            'system-ui',
            'Segoe UI Emoji',
            'Segoe UI Symbol',
            coreText.fontFamily.segoeUI,
            'Apple Color Emoji',
            'Twemoji Mozilla',
            'Noto Color Emoji',
            'Android Emoji',
            coreText.fontFamily.sfPro,
            'Almaden Sans',
            coreText.fontFamily.roboto,
            coreText.fontFamily.ubuntu,
            'Helvetica',
            'Arial',
        ]
            // // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            // .map((name) => `"${name}"`)
            .join(','),
        fontSize: coreText.fontSize,
        fontWeight: coreText.fontWeight,
        lineHeight: coreText.lineHeight,
    };
}
